export default "__VITE_ASSET__kBb$0$q___"